import { BlocksIconMenu } from 'blocks-nextjs/blocks-web-components/components/icon/icons/menu';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconMenu = createComponent({ react: React, tagName: 'cat-icon-menu', elementClass: BlocksIconMenu });
